// Landing route per role after login
export const ROLE_HOME = {
  platform_admin: "/super-admin",
  super_admin: "/",
  admin: "/",
  manager: "/reports",
  doctor: "/doctor-dashboard",
  reception: "/opd",
  nurse: "/ipd",
  lab: "/investigations",
  pharmacy: "/pharmacy",
  billing: "/billing",
  accounts: "/reports",
  hr: "/hrms",
};

export const homeFor = (role) => ROLE_HOME[role] || "/";
